import * as Updates from 'expo-updates';
import i18n from "utils/i18n";
import _ from 'lodash';
import HelperPlatform from "utils/helper-platform";
import HelperAlerts from 'utils/HelperAlerts'
import HelperDate from 'utils/helper-date'

export default class AppUpdater {
	
	lastCheck = null;
	update = null;
	updateIsAvailable = false;
	didFetch = false;
	fetchResult = null;
	errors = [];
	
	log = ( value ) => {
		console.prefix( 'AppUpdater', value );
	}
	
	check = async ({ force = false } = {} ) => {
		const xAgo = HelperDate.date().subtract(2, 'minutes')
		
		// When not yet checked or longer than x ago, then we can check again
		if( force || this.lastCheck === null || this.lastCheck.isBefore( xAgo ) ) {
			this.lastCheck = HelperDate.date();
			
			if( HelperPlatform.isNotWeb() ) {
				try {
					const update = await Updates.checkForUpdateAsync();
					
					this.update = update;
					this.updateIsAvailable = update.isAvailable;
					this.didFetch = false;
					this.fetchResult = null;
				} catch (e) {
					// handle or log error
					this.errors.push( e )
				}
			}
		}
	}
	
	// ... fetch the update
	fetch = async () => {
		try {
			const result = await Updates.fetchUpdateAsync();
			
			this.fetchResult = JSON.stringify( result );
			this.didFetch = true;
			
		} catch (e) {
			// handle or log error
			this.errors.push( e )
			
			return false;
		}
		
		return true;
	}
	
	// ... notify user of update ...
	reload = async () => {
		try {
			await Updates.reloadAsync();
			
		} catch (e) {
			// handle or log error
			this.errors.push( e )
			
			return false;
		}
		
		return true;
	}
	
	createAlert = ( {callbackStart = null, callbackSuccess = null, callbackError = null } = {} ) => {
		HelperAlerts.alert(
			i18n.t('update.title'),
			i18n.t('update.message'),
			[
				{
					text: i18n.t('update.button_ok'),
					onPress: () => {
						
						if( _.isFunction( callbackStart ) ) {
							callbackStart();
						}
						
						if( !this.didFetch ) {
							this.fetch()
								.then( ( success ) => {
									if( success ) {
										if( _.isFunction( callbackStart ) ) {
											callbackSuccess();
										}
										
										this.reload();
									} else {
										if( _.isFunction( callbackError ) ) {
											callbackError();
										}
										
										HelperAlerts.alert(
											i18n.t('update.failed.title'),
											i18n.t('update.failed.message'),
										);
									}
									//
								})
								.catch( e => {
									// Add the error
									this.errors.push( e )
								})
						} else {
							this.reload();
						}
					}
				}
			],
			{
				cancelable: false
			}
		);
	}
	
	getErrors = () => {
		return _.map( this.errors, error => {
			return error.toString();
		} )
	}
}
